export default __webpack_public_path__ + "locales/pl/Common.json?hash=5eff04b2521d7551eb7cc096d58bc1d5";